export class MaintenanceObject_DTO{
  Root_Object : any;
  Child_Objects : any[];
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/MaintenanceObject_DTO.ts